'use client';
import { Zap, MessageCircle, CheckCircle, Target, BadgeDollarSign } from 'lucide-react';

export default function SolutionsSection() {
  return (
    <section id="solutions" className="w-full bg-[#02020c] relative py-12 lg:py-24 px-4 overflow-hidden">
      {/* Background Image */}
      <img
        src="/images/img_group_94.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover z-0 opacity-30"
      />

      <div className="w-full max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col items-center gap-16 lg:gap-24 w-full">
          {/* Header Section */}
          <div className="flex flex-col items-center gap-[28px] sm:gap-[42px] lg:gap-[56px] w-full">
            <div className="flex flex-col items-center gap-[10px] sm:gap-[15px] lg:gap-[20px] w-full max-w-[779px]">
              <h2 
                className="text-[25px] sm:text-[37px] lg:text-[50px] font-normal leading-[29px] sm:leading-[43px] lg:leading-[57px] text-center w-full"
                style={{ fontFamily: 'Raleway' }}
              >
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">Seu Comercial Operando </span>
                <span className="text-[#ffffff] font-semibold italic">24/7 com Inteligência Total</span>
        
              </h2>

              <p 
                className="text-[13px] sm:text-[19px] lg:text-[26px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] w-full"
                style={{ fontFamily: 'Raleway' }}
              >
                A maioria das empresas tem um problema invisível: leads sendo perdidos por falta de atendimento rápido, vendedores gastando tempo com desqualificados, e follow-ups que nunca acontecem. Pior ainda: não há dados confiáveis para entender onde está o gargalo.
              </p>
              <p></p>
                <p 
                className="text-[13px] sm:text-[19px] lg:text-[26px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] w-full"
                style={{ fontFamily: 'Raleway' }}
              >
                Nossa solução resolve os dois lados da equação: IA no WhatsApp fazendo o trabalho pesado (qualificação, follow-up, nutrição) + Dashboard em tempo real mostrando exatamente o que está funcionando e o que precisa ser ajustado.
                </p>
                <p></p>
                <p 
                className="text-[13px] sm:text-[19px] lg:text-[26px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] w-full"
                style={{ fontFamily: 'Raleway' }}
              >
                <span className="font-bold italic">RESULTADO:</span> Seu time comercial focado apenas em fechar vendas qualificadas, enquanto você tem visibilidade total do ROI de cada etapa do processo.

                </p>
            </div>

            {/* Solutions Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px] sm:gap-[30px] lg:gap-[40px] w-full px-[3px] sm:px-[4px] lg:px-[6px]">
              {/* Solution Card 1 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                {/* Chart Visualization */}
                <div className="relative w-full h-[112px] sm:h-[168px] lg:h-[224px] bg-[#0A0A0A] border border-[#ffffff0f] rounded-[24px] flex items-center justify-center overflow-hidden group">
                  {/* Decorative Background Glow */}
                  <div className="absolute inset-0 bg-cyan-500/10 blur-[40px] opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
                  
                  {/* Main Icon */}
                  <div className="relative z-10 flex flex-col items-center gap-2">
                    <div className="p-4 rounded-full bg-cyan-500/10 border border-cyan-500/20 shadow-[0_0_15px_rgba(6,182,212,0.15)]">
                      <Zap className="w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 text-cyan-400" strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Floating Chat Bubble */}
                  <div className="absolute top-[20%] right-[20%] animate-bounce duration-[3000ms]">
                    <div className="bg-[#0d2f3b] border border-cyan-500/30 p-2 rounded-tr-xl rounded-tl-xl rounded-bl-xl shadow-lg">
                      <MessageCircle className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-300" />
                    </div>
                  </div>
                </div>

                {/* Card Content */}
                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Resposta em 60 Segundos = 391% Mais Chances de Conversão
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Leads que esperam mais de 5 minutos já estão falando com seu concorrente
                  </p>
                </div>
              </div>

              {/* Solution Card 2 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                <img
                  src="/images/img_feat1ure_visual_01.png"
                  alt="Feature Visual"
                  className="w-[210px] h-[145px] sm:w-[290px] sm:h-[200px] lg:w-[380px] lg:h-[262px] self-center"
                />
                
                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Follow-Up com Zero Esforço Humano
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    A IA nunca esquece, nunca desiste, nunca está ocupada
                  </p>
                </div>
              </div>

              {/* Solution Card 3 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                {/* Notification System */}
                <div className="relative w-full h-[112px] sm:h-[168px] lg:h-[224px] flex items-center justify-center">
                  {/* Stack Layer 1 (Bottom) */}
                  <div className="absolute top-[30%] w-[85%] h-[60px] bg-[#1e1e1e] border border-[#ffffff05] rounded-xl transform scale-90 opacity-40 z-0"></div>
                  
                  {/* Stack Layer 2 (Middle) */}
                  <div className="absolute top-[20%] w-[90%] h-[70px] bg-[#1e1e1e] border border-[#ffffff0a] rounded-xl transform scale-95 opacity-70 z-10 shadow-lg"></div>

                  {/* Stack Layer 3 (Top - Main) */}
                  <div className="relative w-[95%] bg-[#131313] border border-[#ffffff0f] rounded-xl p-4 sm:p-5 flex items-center gap-4 shadow-2xl z-20 transform hover:-translate-y-1 transition-transform duration-300">
                    <div className="bg-green-500/10 p-2 sm:p-3 rounded-lg border border-green-500/20">
                      <BadgeDollarSign className="w-5 h-5 sm:w-6 sm:h-6 text-green-400" />
                    </div>
                    <div className="flex flex-col gap-1">
                      <span className="text-[10px] sm:text-xs text-green-400 font-medium tracking-wider uppercase">Nova Venda</span>
                      <span className="text-sm sm:text-base text-white font-semibold">R$ 1.250,00</span>
                    </div>
                    <div className="ml-auto">
                      <span className="text-[10px] text-gray-500">Agora</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Escala Comercial Sem Aumentar Headcount
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Atenda 10x mais leads com o mesmo time de vendas
                  </p>
                </div>
              </div>

              {/* Solution Card 4 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                {/* Financial Dashboard */}
                <div className="flex items-end justify-start w-full mt-[2px] sm:mt-[3px] lg:mt-[4px]">
                  <div className="flex flex-col justify-start items-center w-full mt-[2px] sm:mt-[3px] lg:mt-[4px]">
                    <div className="w-full h-[52px] sm:h-[78px] lg:h-[104px] bg-[#13131388] rounded-[24px] mx-[9px] sm:mx-[13px] lg:mx-[18px]"></div>
                    <div className="bg-[#131313] border border-[#ffffff0f] rounded-[24px] p-[20px] sm:p-[25px] lg:p-[30px] w-full -mt-[39px] sm:-mt-[58px] lg:-mt-[78px] relative overflow-hidden">
                      <span 
                        className="text-[17px] font-normal text-left text-white block mb-[16px] leading-[20.40px]"
                        style={{ fontFamily: 'Raleway' }}
                      >
                        Ticket médio
                      </span>

                      <div className="relative z-10" style={{ width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '10px', display: 'inline-flex' }}>
                        {/* Row 1 */}
                        <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: '6.94px', display: 'inline-flex' }}>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '18.51px', fontFamily: 'Raleway', fontWeight: 300, lineHeight: '22.21px', wordWrap: 'break-word' }}>R$</div>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '30.07px', fontFamily: 'Raleway', fontWeight: 500, lineHeight: '36.09px', wordWrap: 'break-word' }}>341,092.57</div>
                          <img src="/images/img_group_white_a700.svg" alt="info" style={{ width: '13.88px', height: '13.88px' }} />
                        </div>

                        {/* Row 2 */}
                        <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: '4.99px', display: 'inline-flex' }}>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '13.31px', fontFamily: 'Raleway', fontWeight: 300, lineHeight: '15.97px', wordWrap: 'break-word' }}>R$</div>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '21.63px', fontFamily: 'Raleway', fontWeight: 500, lineHeight: '25.96px', wordWrap: 'break-word' }}>41,092.57</div>
                          <img src="/images/img_group_white_a700.svg" alt="info" style={{ width: '9.98px', height: '9.98px' }} />
                        </div>

                        {/* Row 3 */}
                        <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: '4.15px', display: 'inline-flex' }}>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '11.08px', fontFamily: 'Raleway', fontWeight: 300, lineHeight: '13.29px', wordWrap: 'break-word' }}>R$</div>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '18px', fontFamily: 'Raleway', fontWeight: 500, lineHeight: '21.60px', wordWrap: 'break-word' }}>1,092.57</div>
                          <img src="/images/img_group_white_a700.svg" alt="info" style={{ width: '8.31px', height: '8.31px' }} />
                        </div>

                        {/* Row 4 */}
                        <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: '3.28px', display: 'inline-flex' }}>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '8.74px', fontFamily: 'Raleway', fontWeight: 300, lineHeight: '10.49px', wordWrap: 'break-word' }}>R$</div>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '14.21px', fontFamily: 'Raleway', fontWeight: 500, lineHeight: '17.05px', wordWrap: 'break-word' }}>492.57</div>
                          <img src="/images/img_group_white_a700.svg" alt="info" style={{ width: '6.56px', height: '6.56px' }} />
                        </div>

                        {/* Row 5 */}
                        <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: '2.67px', display: 'inline-flex' }}>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '7.11px', fontFamily: 'Raleway', fontWeight: 300, lineHeight: '8.53px', wordWrap: 'break-word' }}>R$</div>
                          <div style={{  justifyContent: 'center', display: 'flex', flexDirection: 'column', color: 'white', fontSize: '11.55px', fontFamily: 'Raleway', fontWeight: 500, lineHeight: '13.86px', wordWrap: 'break-word' }}>92.57</div>
                          <img src="/images/img_group_white_a700.svg" alt="info" style={{ width: '5.33px', height: '5.33px' }} />
                        </div>
                      </div>

                      {/* Arrow Graphic */}
                      <img 
                        src="/images/img_vector_4.svg" 
                        alt="Growth Arrow" 
                        className="absolute bottom-[35px] left-[70px] sm:left-[90px] lg:left-[120px] w-[80px] sm:w-[110px] lg:w-[140px]"
                      />

                      {/* Decorative Border/Glow */}
                      <div 
                        className="absolute inset-0 w-full h-full rounded-[18px] pointer-events-none"
                        style={{
                          boxShadow: '0px 0px 8.300000190734863px #0D2F3B',
                          outline: '2px solid #0D2F3B',
                          outlineOffset: '-1px'
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Aumento Direto no Faturamento com Atendimento de Alta Performance 24/7
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Todo lead atendido com a mesma excelência do seu melhor vendedor, sem variação de humor ou cansaçoA IA mostra onde seu processo comercial está travando
                  </p>
                </div>
              </div>

              {/* Solution Card 5 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                {/* Dashboard Overview */}
                <div className="flex items-end justify-start w-full mt-[2px] sm:mt-[3px] lg:mt-[4px]">
                  <div className="flex flex-col justify-start items-center w-full mt-[2px] sm:mt-[3px] lg:mt-[4px]">
                    <div className="w-full h-[52px] sm:h-[78px] lg:h-[104px] bg-[#13131388] rounded-[24px] mx-[9px] sm:mx-[13px] lg:mx-[18px]"></div>
                    <div className="bg-[#131313] border border-[#ffffff0f] rounded-[24px] p-[21px] sm:p-[31px] lg:p-[42px] w-full -mt-[39px] sm:-mt-[58px] lg:-mt-[78px]">
                      <div className="flex flex-col justify-start items-start w-full">
                        <span 
                          className="text-[9px] sm:text-[13px] lg:text-[17px] font-light leading-[10px] sm:leading-[15px] lg:leading-[20px] text-left text-[#ffffff]"
                          style={{ fontFamily: 'Raleway' }}
                        >
                          <span style={{ fontFamily: 'Raleway' }}>Resumo, </span>
                          <span style={{ fontFamily: 'Raleway' }}>Visão Geral</span>
                        </span>
                        
                        {/* Revenue Display */}
                        <div className="flex items-start gap-[3px] sm:gap-[4px] lg:gap-[6px] justify-start w-auto mt-[5px] sm:mt-[7px] lg:mt-[10px]">
                          <span 
                            className="text-[9px] sm:text-[13px] lg:text-[18px] font-light leading-[10px] sm:leading-[14px] lg:leading-[19px] text-left text-[#ffffff] mt-[3px] sm:mt-[4px] lg:mt-[6px]"
                            style={{ fontFamily: 'Raleway' }}
                          >
                            R$
                          </span>
                          <span 
                            className="text-[30.07px] font-medium leading-[36.09px] text-left text-white self-center"
                            style={{ fontFamily: 'Raleway' }}
                          >
                            341,092.57
                          </span>
                          <img
                            src="./images/img_group_white_a700.svg"
                            alt="Trend Up"
                            className="w-[6px] h-[6px] sm:w-[9px] sm:h-[9px] lg:w-[12px] lg:h-[12px] mt-[5px] sm:mt-[7px] lg:mt-[10px]"
                          />
                        </div>

                        {/* Time Period Selector */}
                        <div className="flex items-center gap-[2px] sm:gap-[3px] lg:gap-[4px] justify-start w-full bg-[#ee522113] shadow-[0px_2px_13px_#ee522113] border border-[#ffffff13] rounded-[4px] p-[3px] sm:p-[4px] lg:p-[6px] mt-[2px] sm:mt-[3px] lg:mt-[4px] mr-[3px] sm:mr-[4px] lg:mr-[6px]">
                          <button className="bg-[#0d2f3b] shadow-[0px_1px_8px_#0d2f3b] border border-[#ffffff38] rounded-[3px] py-[2px] sm:py-[3px] lg:py-[4px] px-[8px] sm:px-[12px] lg:px-[16px] w-full">
                            <span 
                              className="text-[4px] sm:text-[6px] lg:text-[8px] font-semibold leading-[4px] sm:leading-[7px] lg:leading-[9px] text-center uppercase text-[#ffffff]"
                              style={{ fontFamily: 'Archivo' }}
                            >
                              Hoje
                            </span>
                          </button>
                          <button className="bg-[#1c1c1c] border border-[#ffffff38] rounded-[3px] py-[2px] sm:py-[3px] lg:py-[4px] px-[8px] sm:px-[12px] lg:px-[16px] w-full">
                            <span 
                              className="text-[4px] sm:text-[6px] lg:text-[8px] font-semibold leading-[4px] sm:leading-[7px] lg:leading-[9px] text-center uppercase text-[#ffffff]"
                              style={{ fontFamily: 'Archivo' }}
                            >
                              mensal
                            </span>
                          </button>
                          <button className="bg-[#1c1c1c] border border-[#ffffff38] rounded-[3px] py-[2px] sm:py-[3px] lg:py-[4px] px-[8px] sm:px-[12px] lg:px-[16px] w-full">
                            <span 
                              className="text-[4px] sm:text-[6px] lg:text-[8px] font-semibold leading-[4px] sm:leading-[7px] lg:leading-[9px] text-center uppercase text-[#ffffff]"
                              style={{ fontFamily: 'Archivo' }}
                            >
                              anual
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Dashboard de ROI em Tempo Real - Decisões Baseadas em Dados
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Pare de adivinhar, comece a saber exatamente onde está o dinheiro    
                  </p>
                </div>
              </div>

              {/* Solution Card 6 */}
              <div className="bg-gradient-to-b from-[#1e1e1e6b] to-[#14141400] border border-[#ffffff0f] rounded-[24px] p-6 sm:p-8 lg:p-10 flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
                {/* Competitor Analysis */}
                <div className="relative w-full h-[106px] sm:h-[159px] lg:h-[212px] mt-[6px] sm:mt-[9px] lg:mt-[12px] bg-[#0A0A0A] border border-[#ffffff0f] rounded-[24px] flex items-center justify-center overflow-hidden group">
                   {/* Background Target Circles */}
                   <div className="absolute inset-0 flex items-center justify-center opacity-10">
                      <div className="w-[150%] h-[150%] border border-cyan-500/30 rounded-full absolute animate-pulse"></div>
                      <div className="w-[100%] h-[100%] border border-cyan-500/30 rounded-full absolute"></div>
                      <div className="w-[50%] h-[50%] border border-cyan-500/30 rounded-full absolute"></div>
                   </div>

                   {/* Main Target Icon */}
                   <div className="relative z-10 p-5 rounded-full bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-cyan-500/20 shadow-[0_0_20px_rgba(6,182,212,0.1)]">
                      <Target className="w-10 h-10 sm:w-14 sm:h-14 lg:w-16 lg:h-16 text-cyan-400" />
                   </div>
                   
                   {/* Success Badge */}
                   <div className="absolute bottom-[20%] right-[25%] bg-[#0d2f3b] border border-cyan-500/30 rounded-full p-1.5 shadow-lg animate-bounce duration-[2000ms]">
                      <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 text-green-400" />
                   </div>
                </div>

                <div className="flex flex-col items-center gap-2 sm:gap-3 lg:gap-4 w-full px-1 sm:px-2 lg:px-3">
                  <h3 
                    className="text-[18px] sm:text-[22px] lg:text-[26px] font-semibold leading-tight text-center text-[#ffffff] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Elimine a Loteria do Atendimento - Todos os Leads Recebem o Pitch Perfeito
                  </h3>
                  <p 
                    className="text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-relaxed text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Seu melhor discurso de vendas, replicado infinitamente sem perder qualidade
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}